import { render } from "./cTaskStatusIcon.vue?vue&type=template&id=6b8192de"
import script from "./cTaskStatusIcon.vue?vue&type=script&lang=js"
export * from "./cTaskStatusIcon.vue?vue&type=script&lang=js"

import "./cTaskStatusIcon.vue?vue&type=style&index=0&id=6b8192de&lang=css"

import exportComponent from "C:\\EPS_Code\\Clockwork_FrontandBack\\ClockWork.Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__